import { useEffect, useState } from "react";

const useHorizontalScroll = (ref) => {
  const [scrollDistance, setScrollDistance] = useState(0);

  const canScroll = () => {
    let rect;
    let scroller;

    if (ref && ref.current) {
      rect = ref.current.getBoundingClientRect();
      scroller = ref.current.firstElementChild;
    }

    return (
      scroller.offsetLeft >= rect.left ||
      scroller.offsetLeft + scroller.offsetWidth <= rect.width
    );
  };

  const scrollHandler = (e) => {
    e.preventDefault();

    const rawData = e.deltaY ? e.deltaY : e.deltaX;
    const mouseY = Math.floor(rawData);

    const newAnimationValue = scrollDistance + mouseY;

    if (!canScroll()) {
      return;
    }

    setScrollDistance(newAnimationValue);
  };

  useEffect(() => {
    if (ref?.current?.scrollLeft) {
      ref.current.scrollLeft -= scrollDistance;
    }
  }, [scrollDistance]);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.addEventListener("wheel", scrollHandler, { passive: false });

      return () => {
        ref?.current?.removeEventListener("wheel", scrollHandler);
      };
    }
    return null;
  }, []);

  return [scrollDistance];
};

export default useHorizontalScroll;
